export const learningObjectiveSchema = { name: "" };
export const lessonSchema = {
	name: "",
	code: "",
	filepath: "",
	learningObjectives: [],
	category: "",
	isCustomLesson: false,
	testAndReviewURL: "",
	classworkURL: "",
	homeworkURL: "",
};

export const newLessonSchema = (category) => ({ ...lessonSchema, category });

export const courseSchema = {
	name: "",
	price: 0,
	lessons: [],
};

export const lessonCategoriesMap = {
	JUNIOR: "Junior",
	INTERMEDIATE: "Intermediate",
	ADVANCED: "Advanced",
};

export const lessonCategories = Object.values(lessonCategoriesMap);

export const mapLessonsByCategory = (lessons) => {
	const indexedLessons =
		lessons?.map((lesson, index) => ({
			...lesson,
			index,
		})) || [];
	return lessonCategories.map((category) => ({
		category,
		lessons: indexedLessons.filter((lesson) => category === lesson.category).map((lesson) => ({ ...lesson })),
	}));
};
